import { c as _c } from "react/compiler-runtime";
import { isEqual } from 'lodash';
import { useCallback, useState } from 'react';
import { BalanceSheetConfigColumn } from '../BalanceSheetConfigPanel.types';
function getHiddenColumnIdsFromColumns(columns: BalanceSheetConfigColumn[]): Set<string> {
  return new Set(columns.filter(col => col.isHidden && !col.isTotalColumn).map(col => col.id));
}
interface UseDraftHiddenColumnsArgs {
  setDraftHiddenColumns: (hidden: Set<string> | null) => void;
}
export interface UseDraftHiddenColumnsReturn {
  hiddenColumns: Set<string>;
  toggleVisibility: (columnId: string, visible: boolean) => void;
  isDirty: boolean;
  commitSnapshot: () => void;
  revert: () => void;
  reinitialize: (columns: BalanceSheetConfigColumn[]) => void;
  clearDraft: () => void;
}
export function useDraftHiddenColumns(t0) {
  const $ = _c(22);
  const {
    setDraftHiddenColumns
  } = t0;
  const [hiddenColumns, setHiddenColumns] = useState(_temp);
  const [serverHidden, setServerHidden] = useState(hiddenColumns);
  let t1;
  if ($[0] !== setDraftHiddenColumns) {
    t1 = (columnId, visible) => {
      setHiddenColumns(prev => {
        const next = new Set(prev);
        if (visible) {
          next.delete(columnId);
        } else {
          next.add(columnId);
        }
        setDraftHiddenColumns(next);
        return next;
      });
    };
    $[0] = setDraftHiddenColumns;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleVisibility = t1;
  let t2;
  bb0: {
    const server = serverHidden;
    if (server.size !== hiddenColumns.size) {
      t2 = true;
      break bb0;
    }
    let t3;
    if ($[2] !== hiddenColumns || $[3] !== server) {
      t3 = isEqual(Array.from(server).sort(), Array.from(hiddenColumns).sort());
      $[2] = hiddenColumns;
      $[3] = server;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = !t3;
  }
  const isDirty = t2;
  let t3;
  if ($[5] !== hiddenColumns) {
    t3 = () => {
      setServerHidden(new Set(hiddenColumns));
    };
    $[5] = hiddenColumns;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const commitSnapshot = t3;
  let t4;
  if ($[7] !== serverHidden || $[8] !== setDraftHiddenColumns) {
    t4 = () => {
      setHiddenColumns(serverHidden);
      setDraftHiddenColumns(null);
    };
    $[7] = serverHidden;
    $[8] = setDraftHiddenColumns;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const revert = t4;
  let t5;
  if ($[10] !== setDraftHiddenColumns) {
    t5 = columns => {
      const initialHidden = getHiddenColumnIdsFromColumns(columns);
      setHiddenColumns(initialHidden);
      setServerHidden(initialHidden);
      setDraftHiddenColumns(null);
    };
    $[10] = setDraftHiddenColumns;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const reinitialize = t5;
  let t6;
  if ($[12] !== setDraftHiddenColumns) {
    t6 = () => {
      setDraftHiddenColumns(null);
    };
    $[12] = setDraftHiddenColumns;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const clearDraft = t6;
  let t7;
  if ($[14] !== clearDraft || $[15] !== commitSnapshot || $[16] !== hiddenColumns || $[17] !== isDirty || $[18] !== reinitialize || $[19] !== revert || $[20] !== toggleVisibility) {
    t7 = {
      hiddenColumns,
      toggleVisibility,
      isDirty,
      commitSnapshot,
      revert,
      reinitialize,
      clearDraft
    };
    $[14] = clearDraft;
    $[15] = commitSnapshot;
    $[16] = hiddenColumns;
    $[17] = isDirty;
    $[18] = reinitialize;
    $[19] = revert;
    $[20] = toggleVisibility;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp() {
  return new Set();
}